<template>
  <div class="main-container">
    <!-- 初期表示時の日付選択エリア -->
    <div class="initial-date-selection" v-if="!isComponentActive">
      <div class="selection-container">
        <div class="d-flex justify-content-center align-items-center mb-4">
          <img src="@/assets/img/details_sub.jpg" alt="ボーナス明細" class="mr-3" style="width: 75px; height: auto;" />
          <h2 class="text-center mb-0">ボーナス明細</h2>
        </div>
        <div class="date-selection py-2">
          <div class="d-flex justify-content-between align-items-center sp_column">
            <label class="mt-2">対象年月</label>
            <div class="date-selector d-flex align-items-center sp_column">
              <div class="year-selector mx-2 mt-2">
                <select v-model="selectedYear" @change="handleYearChange">
                  <option v-for="year in yearOptions" :key="year" :value="year">
                    {{ year }}年
                  </option>
                </select>
              </div>
              <div class="month-selector ml-2 mt-2">
                <select
                  v-model="selectedMonthValue"
                  @change="handleMonthChange"
                  :disabled="!selectedYear"
                >
                  <option value="">月を選択</option>
                  <option
                    v-for="month in monthOptions"
                    :key="month"
                    :value="month"
                  >
                    {{ month }}月
                  </option>
                </select>
              </div>
              <div class="ml-2 mt-2">
                <button
                  class="btn"
                  @click="fetchData"
                  :disabled="!selectedYear || !selectedMonthValue"
                >
                  表示する
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 表示コンポーネントの排他的切り替え -->
    <BonusDetailContainer
      v-if="activeView === 'monthly' && isComponentActive"
      :detail-data="detailData"
      :display-type="displayType"
      :fiscalYear="fiscalYear"
      :additional-sections="additionalSections"
      :initial-year="selectedYear"
      :initial-month="selectedMonthValue"
      :year-options="yearOptions"
      :current-year="currentYear"
      :display-base-month="displayBaseMonth"
      @change-tab="changeTab"
      @show-commission="showCommission"
      @date-changed="changeDate"
    />

    <BonusYearDetail
      v-if="activeView === 'yearly' && isComponentActive"
      :yearly-data="yearlyData"
      :selected-year="selectedYearlyYear"
      @change-tab="changeTab"
      @year-changed="changeYear"
    />

    <!-- componentsisactive が true かつ commissionData が存在する場合にのみ表示 -->
    <BonusCommissionDetail
      v-if="activeView === 'commission' && isComponentActive"
      :commission-data="commissionData"
      :detail-result="detailResult"
      @back="activeView = 'monthly'"
    />
  </div>
</template>

<script>
import BonusDetailContainer from "./BonusDetailContainer.vue";
import BonusYearDetail from "./BonusYearDetail.vue";
import BonusCommissionDetail from "./BonusCommissionDetail.vue";
import Message from "@/modules/Message";
import Request from "@/modules/Request";
let request = new Request();

export default {
  name: "MainContainer",
  components: {
    BonusDetailContainer,
    BonusYearDetail,
    BonusCommissionDetail,
  },
  data() {
    // 現在の年月を取得
    const now = new Date();
    const currentYear = now.getFullYear();
    // 当月の前月を基準とする
    const currentMonth = now.getMonth(); // 0-11の範囲（1月が0）
    const displayBaseMonth = currentMonth + 1; // 1-12の範囲に変換

    // 前月を設定（1月の場合は前年の12月）
    const prevMonth = currentMonth === 0 ? 12 : currentMonth;
    const yearForPrevMonth = currentMonth === 0 ? currentYear - 1 : currentYear;

    // YYYY/MM形式の文字列を作成
    const formattedMonth = `${yearForPrevMonth}/${prevMonth
      .toString()
      .padStart(2, "0")}`;

    return {
      activeView: "monthly", // 'monthly', 'yearly', 'commission'
      selectedMonth: formattedMonth,
      displayType: "normal", // 'normal', 'error', 'expired'
      detailData: null,
      detailResult: null,
      yearlyData: null,
      commissionData: null,
      additionalSections: [null],
      isComponentActive: false,
      // 日付選択用
      selectedYear: yearForPrevMonth.toString(),
      selectedMonthValue: prevMonth.toString(),
      selectedYearlyYear: yearForPrevMonth.toString(), // 年次表示用の年（月次とは独立して保持）
      yearOptions: this.generateYearOptions(currentYear),
      monthOptions: [],
      currentYear,
      displayBaseMonth,
      isTabSwitching: false, // タブ切り替え中かどうかを示すフラグ
    };
  },
  mounted() {
    console.log("初期activeView:", this.activeView);
    console.log("Detail mounted");
    // 初期表示時に月の選択肢を設定
    this.updateMonthOptions();
    // mountedでのfetchDataは行わない
  },
  methods: {
    // 年選択肢生成メソッド
    generateYearOptions(currentYear) {
      // 現在の年から過去5年分の年を生成
      const years = [];
      for (let i = 0; i < 5; i++) {
        years.push((currentYear - i).toString());
      }
      return years;
    },
    // 年変更時の処理
    handleYearChange() {
      // 年が変更されたら月を未選択に
      this.selectedMonthValue = "";
      // 年に基づいて月の選択肢を更新
      this.updateMonthOptions();
    },
    // 月の選択肢更新
    updateMonthOptions() {
      // 選択された年に基づいて利用可能な月の選択肢を設定
      const selectedYearNum = parseInt(this.selectedYear);
      const currentYearNum = this.currentYear;
      const baseMonth = this.displayBaseMonth; // 表示基準月（当月）
      let availableMonths = [];

      // 詳細なデバッグログ
      console.log(
        "月選択肢更新 - 選択年:",
        selectedYearNum,
        "現在年:",
        currentYearNum,
        "基準月:",
        baseMonth
      );

      if (selectedYearNum === currentYearNum) {
        // 当年の場合、1月から前月までを表示（前月は含む、当月は含まない）
        const lastMonth = baseMonth === 1 ? 12 : baseMonth - 1;
        availableMonths = Array.from({ length: lastMonth }, (_, i) =>
          (i + 1).toString()
        );
        console.log("  当年のため 1月~前月までを表示。表示最終月:", lastMonth);
      } else if (selectedYearNum === currentYearNum - 4) {
        // 5年前の場合、表示基準月と同じ月から12月までを表示
        // 例: 現在が3月なら、5年前の3月から12月までを表示
        const startMonth = baseMonth;

        if (startMonth <= 12) {
          availableMonths = Array.from({ length: 13 - startMonth }, (_, i) =>
            (i + startMonth).toString()
          );
          console.log("  5年前のため 基準月(", startMonth, ")~12月までを表示");
        } else {
          console.log("  5年前だが基準月が12を超えているため表示なし");
        }
      } else {
        // その他の年の場合、すべての月を表示（2~4年前）
        availableMonths = Array.from({ length: 12 }, (_, i) =>
          (i + 1).toString()
        );
        console.log("  2~4年前のためすべての月(1~12)を表示");
      }

      this.monthOptions = availableMonths;
    },
    // 月変更時の処理
    handleMonthChange() {
      // 月が変更されたら年月の選択状態を更新
      this.updateSelectedMonth();
    },
    // 選択された年月の更新
    updateSelectedMonth() {
      // 年と月が選択されている場合のみ更新
      if (this.selectedYear && this.selectedMonthValue) {
        this.selectedMonth = `${
          this.selectedYear
        }/${this.selectedMonthValue.padStart(2, "0")}`;
        console.log("選択された年月:", this.selectedMonth);
      }
    },
    changeTab(tab) {
      this.isTabSwitching = true; // タブ切り替えフラグをONにする
      this.activeView = tab === "monthly" ? "monthly" : "yearly";
      
      // タブ切り替え後の処理
      if (tab === "monthly") {
        // 月次表示に切り替える場合、月次用の年月情報を使用
        console.log("月次タブに切り替え - 年月:", this.selectedMonth, "年:", this.selectedYear);
      } else if (tab === "yearly") {
        // 年次表示に切り替える場合、年次用の年を使用
        
        // yearlyDataが存在してselectedYear情報がある場合は、それを優先的に使用
        if (this.yearlyData && this.yearlyData.selectedYear) {
          // 年次データの選択年を年次表示の選択年に反映
          this.selectedYearlyYear = this.yearlyData.selectedYear;
          console.log("年次タブに切り替え - 年次データの選択年を使用:", this.selectedYearlyYear);
        }
        
        console.log("年次タブに切り替え - 年次用年:", this.selectedYearlyYear, "（月次の年:", this.selectedYear, "）");
        
        // 注：年次データは月次データ取得時に既に取得済みのため、ここでは追加の取得は行わない
        // yearlyDataが存在しない場合のみ警告ログを表示
        if (!this.yearlyData || !this.yearlyData.isGetYearlyData) {
          console.warn("年次データが存在しません。月次データを先に取得してください。");
        }
      }
      
      // タブ切り替え後、一定時間後にフラグをリセット
      setTimeout(() => {
        this.isTabSwitching = false;
      }, 300); // タイムアウトを少し長めに設定
    },
    showCommission() {
      this.activeView = "commission";
    },
    changeDate(date) {
      this.selectedMonth = date;
      
      // 年月をYYYY/MMから分解して、ドロップボックスの選択値を更新
      if (date && date.includes('/')) {
        const [year, month] = date.split('/');
        this.selectedYear = year;
        // 月の先頭の0を除去（例: '02' → '2'）して設定
        this.selectedMonthValue = month.replace(/^0+/, '');
        
        // 月次表示で年が変更された場合、年次表示の初期表示用の年も更新する
        // （月次から年次に切り替えた時に同じ年が表示されるようにするため）
        this.selectedYearlyYear = year;
        
        console.log("年月が変更されました - 年:", this.selectedYear, "月:", this.selectedMonthValue, "年次用年:", this.selectedYearlyYear);
      }
      
      // タブ切り替え中でない場合のみデータを取得する
      if (!this.isTabSwitching) {
        this.fetchData();
      }
    },
    changeYear(year) {
      // 年次データの年が変更されたときの処理
      console.log("年次データの年が変更されました:", year);
      
      // 年次表示用の年のみを更新（月次表示の年には影響させない）
      this.selectedYearlyYear = year;
      console.log("年次用年を更新:", this.selectedYearlyYear, "（月次の年は変更なし:", this.selectedYear, "）");
      
      // 年次データのみを取得するリクエストを送信
      this.fetchYearlyData(year);
    },
    async fetchYearlyData(year) {
      try {
        console.log("fetchYearlyData:", year);
        // 1:年データのみ取得
        let postParams = [year, 1];
        let requestParams = request.createParams(
          "webMdlResult",
          "getDetailResult",
          postParams
        );
        request
          .create()
          .post("", requestParams)
          .then((data) => {
            if (data.Is_Error != 1) {
              console.log("年次データ取得結果:", data);
              // 年次データを更新
              if (data && data.YearlyResult) {
                // 年次データの選択年を保存 - YearlyResultから年を優先して使用し、なければ引数のyearを使用
                const yearToUse = data.YearlyResult.selectedYear || year;
                
                // 年次用の選択年を更新（これが年次表示の初期値となる）
                this.selectedYearlyYear = yearToUse;
                
                this.yearlyData = {
                  selectedYear: yearToUse,
                  totalPayment: data.YearlyResult.totalPayment || "0",
                  totalWithholding: data.YearlyResult.totalWithholding || "0",
                  months: data.YearlyResult.months ? JSON.parse(data.YearlyResult.months) : [],
                  isGetYearlyData: true, 
                };
                
                console.log("更新された年次データ:", this.yearlyData);
                console.log("年次用の選択年も更新:", this.selectedYearlyYear);
              }else{
                this.yearlyData = {
                  selectedYear: year, // 年次データがない場合でも選択年を保存
                  isGetYearlyData: false,
                };
                
                // 年次データが取得できなくても選択年は更新する
                this.selectedYearlyYear = year;
                console.log("年次データなし、選択年のみ更新:", year);
              }
            } else {
              this.isComponentActive = false;
              Message.error().fire({
                title: 'データがありません',
              });
            }
          });
      } catch (error) {
        console.error("年次データ取得エラー:", error);
      }
    },
    async fetchData() {
      try {
        console.log("fetchData");
        // 0:すべて取得
        // 1:年データのみ取得
        let postParams = [this.selectedMonth, 0];
        let requestParams = request.createParams(
          "webMdlResult",
          "getDetailResult",
          postParams
        );
        request
          .create()
          .post("", requestParams)
          .then((data) => {
            console.log("data", data);

            if (data.Is_Error != 1) {
              // DetailResultデータを直接保存
              this.detailResult = data.DetailResult;
              let hasRegistrationNumber = false;
              if(data.DetailResult.hasRegistrationNumber === "true"){
                hasRegistrationNumber = true;
              }

              this.detailData = {
                month: this.selectedMonth,
                member: data.DetailResult.member,
                displayType: data.DetailResult.displayType,
                fiscalYear: data.DetailResult.fiscalYear,
                displayType_page: data.DetailResult.displayType_page,
                payment: {
                  date: data.DetailResult.date,
                  amount: data.DetailResult.amount,
                  errorReason: data.DetailResult.errorReason,
                  expirationDate: data.DetailResult.expirationDate,
                  expirationDateManual: data.DetailResult.expirationDateManual,
                  paymentInfo: data.DetailResult.paymentInfo,
                },
                commission: {
                  total: data.DetailResult.total,
                  normal: data.DetailResult.normal,
                  j: data.DetailResult.j,
                  subsidiary: data.DetailResult.subsidiary,
                  adjustment: data.DetailResult.adjustment,
                  return: data.DetailResult.return,
                  totalWithTax: data.DetailResult.totalWithTax,
                  totalWithoutTax: data.DetailResult.totalWithoutTax,
                  consumptionTax: data.DetailResult.consumptionTax,
                  transitionalWithoutTax:
                    data.DetailResult.transitionalWithoutTax,
                  transitionalTax: data.DetailResult.transitionalTax,
                  withholdingTax: data.DetailResult.withholdingTax,
                  totalAfterDeductions: data.DetailResult.totalAfterDeductions,
                  notificationFee: data.DetailResult.notificationFee,
                  paymentAmount: data.DetailResult.paymentAmount,
                  hasSubsidiaryCommission: true,
                  hasRegistrationNumber: hasRegistrationNumber,
                },
                registration: {
                  companyName: "株式会社マナビス化粧品",
                  companyRegistrationNumber: "T3040001030675",
                  registrationNumber: data.DetailResult.registrationNumber,
                },
              };

              // campDataの処理
              if (data.DetailResult.campData) {
                try {
                  const campData = JSON.parse(data.DetailResult.campData);
                  // 配列であればそのまま、配列でなければ配列に変換して設定
                  this.additionalSections = Array.isArray(campData)
                    ? campData
                    : [campData];
                  console.log(
                    "AddSection1用データセット:",
                    this.additionalSections
                  );
                } catch (e) {
                  console.error("campDataのパース中にエラー:", e);
                  this.additionalSections = [null]; // エラー時は空を設定
                }
              } else {
                this.additionalSections = [null]; // campDataがない場合は空を設定
              }

              // 年次データ
              if (data.YearlyResult) {
                this.yearlyData = {
                  selectedYear: data.YearlyResult.selectedYear,
                  totalPayment: data.YearlyResult.totalPayment,
                  member: data.DetailResult.member,
                  totalWithholding: data.YearlyResult.totalWithholding,
                  months: JSON.parse(data.YearlyResult.months),
                  isGetYearlyData: true,
                };
                
                // 月次データの取得時に年次用の年も更新（年次表示でも同じ年が表示されるようにする）
                if (data.YearlyResult.selectedYear) {
                  this.selectedYearlyYear = data.YearlyResult.selectedYear;
                  console.log("月次データ取得時に年次用年を更新:", this.selectedYearlyYear);
                }
              }else{
                this.detailData.isGetYearlyData = false;
                this.yearlyData = {
                  isGetYearlyData: false,
                };
              }
              // コミッションデータ
              if (data.CommissionResult) {
                this.commissionData = {
                  month: data.CommissionResult.month,
                  member: data.DetailResult.member,
                  stages: JSON.parse(data.CommissionResult.stages),
                };
              }else{
                this.detailData.commission.hasSubsidiaryCommission = false;
                this.commissionData = null;
              }
              console.log("detailData", this.detailData);
              console.log("yearlyData", this.yearlyData);
              console.log("commissionData", this.commissionData);

              // データ取得後にコンポーネントを表示
              this.isComponentActive = true;

              if (this.message) {
                Message.error().fire({
                  title: this.message,
                });
              }
            } else {
              this.isComponentActive = false;
              Message.error().fire({
                title: 'データがありません',
              });
            }
          });
      } catch (error) {
        console.error("データ取得エラー:", error);
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  max-width: 800px;
  margin: 0 auto;
}

/* 初期日付選択エリアのスタイル */
.initial-date-selection {
  max-width: 800px;
  margin: 0 auto;
  font-family: "Hiragino Sans", "Meiryo", sans-serif;
  color: #333;
  background-color: #fff;
  padding: 20px 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.selection-container {
  max-width: 500px;
  margin: 40px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

/* .date-selection select {
  padding: 5px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
} */

/* .year-selector select,
.month-selector select {
  padding: 5px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  width: 100%;
}

.year-selector {
  width: 120px;
  margin-right: 10px;
} */

.month-selector {
  width: 120px;
}

.btn-primary {
  background-color: #e74c3c;
  border-color: #e74c3c;
  padding: 8px 20px;
  font-size: 1rem;
  border-radius: 4px;
}

.btn-primary:hover {
  background-color: #c0392b;
  border-color: #c0392b;
}

.btn-primary:disabled {
  background-color: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
}

/* 灰色ボタン用スタイル追加 */
.btn-gray {
  background-color: #ffffff;
  border-color: #333;
  color: #333;
  padding: 5px 15px;
  font-size: 0.9rem;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.btn-gray:hover {
  background-color: #f5f5f5;
  border-color: #000;
}

.btn-gray:disabled {
  background-color: #f5f5f5;
  border-color: #ccc;
  color: #999;
  cursor: not-allowed;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.justify-content-between {
  justify-content: space-between;
}

.text-center {
  text-align: center;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mt-3 {
  margin-top: 1rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

/* 共通デザインに調整 */
.btn {
    border: 1px solid #000 !important;
    padding: 10px 20px;
    color: #000 !important;
    font-weight: 300 !important;
    background-color: #fff;
    cursor: pointer;
}
button {
  font-family: Noto Sans JP, ヒラギノ角ゴ Pro, Hiragino Kaku Gothic Pro, メイリオ, Meiryo, sans-serif;
  line-height: 1.8 !important;
  color: #424242 !important;
  font-weight: 300 !important;
  font-size: 1.8rem;
}
select {
  width: 120px;
  height: 36px; 
  font-size: 1.2em;
  border: 1px solid #aaa;
  border-radius: 5px;
  box-sizing: border-box;
}

/* スマートフォンレイアウト */
@media screen and (min-width: 1px) and (max-width: 991px) {
  .sp_column {
    flex-direction: column;
    align-items: center;
  }
}
</style> 